import { render } from "./Spacer.vue?vue&type=template&id=6208bb40&scoped=true"
const script = {}

import "./Spacer.vue?vue&type=style&index=0&id=6208bb40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6208bb40"]])

export default __exports__